import * as types from './types';
const INITIAL_STATE = {
  report: null,
  loading: false,
  loadingStack: [],
  error: null,
  siteCount: null,
  fiscalYears: [],
  status: {},
  verificationCollection: {},
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.VERIFICATION_REPORT_GET_SITE_COUNT:
      return { ...state, siteCount: payload };
    case types.VERIFICATION_REPORT_GET_FISCAL_YEARS:
      return { ...state, fiscalYears: payload };
    case types.VERIFICATION_REPORT_GET_REPORT:
      return { ...state, report: payload };
    case types.VERIFICATION_REPORT_GET_STATUS:
      return { ...state, status: payload };
    case types.VERIFICATION_REPORT_GET_VERIFICATION_COLLECTION:
      return { ...state, verificationCollection: payload };
    case types.VERIFICATION_REPORT_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.VERIFICATION_REPORT_FETCHING:
      let stack = state.loadingStack;

      if (payload) {
        stack.push(true);
      } else {
        stack.pop();
      }

      return {
        ...state,
        loading: stack.length > 0,
        loadingStack: stack,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/verificationreport/state/verificationreport/reducer.js